import { IPostMessage, PollPost, PostType, QuizPost } from "../../types";

export const SplitTags = (text: string): string => {
  const regex = /(<([^>]+)>)/gi
  return text.replace(regex, "");
}

export function isPostPinned<T extends { type: PostType }>(value: T) {
  if (value.type === PostType.Post) {
    return (value as unknown as IPostMessage)?.variants?.some(v => v.pin)
  }

  return false
}

export function isPostWithProtectContent<T extends { type: PostType }>(value: T) {
  if (value.type === PostType.Post) {
    return (value as unknown as IPostMessage)?.variants?.some(v => v.protect_content)
  }

  return false
}

export function isPostWithDisableNotify<T extends { type: PostType }>(value: T) {
  if (value.type === PostType.Post) {
    return (value as unknown as IPostMessage)?.variants?.some(v => v.disable_notify)
  }

  return false
}
